var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ABB822DD-2A7B-462E-8013-7340D8742DB8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-JULY-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Sprite",
    transform: "translate(-90.000000, -2111.000000)",
    fill: "#ffffff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wind-light",
    transform: "translate(90.000000, 2111.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27,1.5 C27,2.325 27.675,3 28.5,3 L34.5,3 C36.984375,3 39,5.015625 39,7.5 C39,9.984375 36.984375,12 34.5,12 L1.5,12 C0.675,12 0,12.675 0,13.5 C0,14.325 0.675,15 1.5,15 L34.5,15 C38.64375,15 42,11.64375 42,7.5 C42,3.35625 38.64375,0 34.5,0 L28.5,0 C27.675,0 27,0.675 27,1.5 Z M33,38.4545455 C33,39.3045455 33.675,40 34.5,40 L39.75,40 C44.30625,40 48,36.1943182 48,31.5 C48,26.8056818 44.30625,23 39.75,23 L1.5,23 C0.675,23 0,23.6954545 0,24.5454545 C0,25.3954545 0.675,26.0909091 1.5,26.0909091 L39.75,26.0909091 C42.646875,26.0909091 45,28.5153409 45,31.5 C45,34.4846591 42.646875,36.9090909 39.75,36.9090909 L34.5,36.9090909 C33.675,36.9090909 33,37.6045455 33,38.4545455 Z M10.5,48 L16.5,48 C20.64375,48 24,44.64375 24,40.5 C24,36.35625 20.64375,33 16.5,33 L1.5,33 C0.675,33 0,33.675 0,34.5 C0,35.325 0.675,36 1.5,36 L16.5,36 C18.984375,36 21,38.015625 21,40.5 C21,42.984375 18.984375,45 16.5,45 L10.5,45 C9.675,45 9,45.675 9,46.5 C9,47.325 9.675,48 10.5,48 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindLight);
export default __webpack_public_path__ + "static/media/wind-light.cdafe759922ebb2093feb5ed5bd22b03.svg";
export { ForwardRef as ReactComponent };